<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_placeholder_search') ||
                  '巡检单号/成品编码/子件编码/产品名称/工厂订单编号/客户订单编号 搜索...'
              "
              type="search"
              @keyup.enter="query"
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>

            <slot name="buttons"></slot>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-drawer
      :visible.sync="advqueryDialogVisible"
      size="600px"
      :close-on-click-modal="false"
      append-to-body
      :with-header="false"
    >
      <div class="d-flex align-items-center justify-content-between mx-4 mt-4">
        <div>
          <span style="color: #101010; font-size: 14px;">
            {{ $l('INDEX.advanced_search') || '高级搜索' }}
          </span>
        </div>
        <div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeAdvqueryDialog">
              {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
            </el-button>
            <el-button size="small" type="warning" @click="reset">
              {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
            </el-button>
            <el-button size="small" type="primary" @click="advquery">
              {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
            </el-button>
          </span>
        </div>
      </div>

      <div class="p-4">
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="100px"
          size="mini"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_status') || '巡检状态'">
                <el-checkbox-group v-model="form.listStatus">
                  <el-checkbox label="N">
                    {{ $l('form_label_status_N') || '新增' }}
                  </el-checkbox>
                  <el-checkbox label="Y">
                    {{ $l('form_label_status_Y') || '已提交' }}
                  </el-checkbox>
                  <el-checkbox label="D">
                    {{ $l('form_label_status_D') || '已删除' }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_checkStatus') || '巡检结果'">
                <el-checkbox-group v-model="form.listCheckStatus">
                  <el-checkbox label="A">
                    {{ $l('form_label_checkStatus_A') || '合格' }}
                  </el-checkbox>
                  <el-checkbox label="P">
                    {{ $l('form_label_checkStatus_P') || '待复查' }}
                  </el-checkbox>
                  <el-checkbox label="R">
                    {{ $l('form_label_checkStatus_R') || '已复查' }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_pendingGoodsInspectionNo') || '巡检单号'"
              >
                <el-input
                  v-model.trim="form.pendingGoodsInspectionNo"
                  :placeholder="
                    $l('form_placeholder_pendingGoodsInspectionNo') ||
                      '请输入检验单号'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="$l('form_label_reportDate') || '检验日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.reportDateStart"
                      :placeholder="
                        $l('form_placeholder_reportDateStart') || '开始日期'
                      "
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.reportDateEnd"
                      :placeholder="
                        $l('form_placeholder_reportDateEnd') || '截止日期'
                      "
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_workShop') || '巡检车间'">
                <dict-select
                  v-model="form.listWorkShopCode"
                  url="/factory/workshop/select"
                  :placeholder="
                    $l('form_placeholder_workShop') || '请选择巡检车间'
                  "
                  size="mini"
                  multiple
                  clearable
                  filterable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="this.$l('form_label_pdProcessDictStep') || '巡检工序'"
              >
                <dict-select
                  v-model="form.listPdProcessDictStep"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'pdProcessDictStep' }"
                  :placeholder="
                    $l('form_placeholder_pdProcessDictStep') || '请选择巡检工序'
                  "
                  size="mini"
                  multiple
                  clearable
                  filterable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_masterNcNo') || '成品编码'">
                <el-input
                  v-model.trim="form.masterNcNo"
                  :placeholder="
                    $l('form_placeholder_masterNcNo') || '请输入成品编码'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_ncNo') || '子件编码'">
                <el-input
                  v-model.trim="form.ncNo"
                  :placeholder="$l('form_placeholder_ncNo') || '请输入子件编码'"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_goodsName') || '产品名称'">
                <el-input
                  v-model.trim="form.goodsName"
                  :placeholder="
                    $l('form_placeholder_goodsName') || '请输入产品名称'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_factoryOrderNo') || '工厂订单编号'"
              >
                <el-input
                  v-model.trim="form.factoryOrderNo"
                  :placeholder="
                    $l('form_placeholder_factoryOrderNo') ||
                      '请输入工厂订单编号'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_custOrderNo') || '客户订单编号'"
              >
                <el-input
                  v-model.trim="form.custOrderNo"
                  :placeholder="
                    $l('form_placeholder_custOrderNo') || '请输入客户订单编号'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_authorBy') || '业务人员'">
                <dict-select
                  v-model="form.listAuthorBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_placeholder_authorBy') || '请选择业务人员'
                  "
                  size="mini"
                  multiple
                  clearable
                  filterable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="$l('form_label_checkedQty') || '巡检数量'"
                >
                  <el-col :span="11">
                    <el-input-number
                      v-model="form.checkedQtyStart"
                      :placeholder="
                        $l('form_placeholder_checkedQtyStart') ||
                          '请输入起始数量'
                      "
                      :min="0"
                      :step="1"
                      :precision="0"
                      :controls="false"
                      style="width:100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-input-number
                      v-model="form.checkedQtyEnd"
                      :placeholder="
                        $l('form_placeholder_checkedQtyEnd') || '请输入截止数量'
                      "
                      :min="0"
                      :step="1"
                      :precision="0"
                      :controls="false"
                      style="width:100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_recheckBy') || '复检人'">
                <dict-select
                  v-model="form.listRecheckBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_placeholder_recheckBy') || '请选择复检人'
                  "
                  size="mini"
                  multiple
                  clearable
                  filterable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="$l('form_label_recheckTime') || '复检时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.recheckTimeStart"
                      :placeholder="
                        $l('form_placeholder_recheckTimeStart') || '开始日期'
                      "
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.recheckTimeEnd"
                      :placeholder="
                        $l('form_placeholder_recheckTimeEnd') || '截止日期'
                      "
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_createBy') || '创建人'">
                <dict-select
                  v-model="form.listCreateBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_placeholder_createBy') || '请选择创建人'
                  "
                  size="mini"
                  multiple
                  clearable
                  filterable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="$l('form_label_createTime') || '创建时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createTimeStart"
                      :placeholder="
                        $l('form_placeholder_createTimeStart') || '开始日期'
                      "
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createTimeEnd"
                      :placeholder="
                        $l('form_placeholder_createTimeEnd') || '截止日期'
                      "
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
                <dict-select
                  v-model="form.listModifyBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_placeholder_modifyBy') || '请选择修改人'
                  "
                  size="mini"
                  multiple
                  clearable
                  filterable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="$l('form_label_modifyTime') || '修改时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeStart"
                      :placeholder="
                        $l('form_placeholder_modifyTimeStart') || '开始日期'
                      "
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      :placeholder="
                        $l('form_placeholder_modifyTimeEnd') || '截止日期'
                      "
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listStatus: ['N', 'Y'],
  listCheckStatus: [],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      reporterList: [],
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')

      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
</style>
